import React, { useEffect, useState } from 'react';

import { TextareaWithConfirm } from 'shared-components';

import { ITravelStatus } from '../../../../../../types';

interface IProps {
  setComplete: (status: boolean) => void;
  travelStatus: ITravelStatus;
  additionalAnswers: {
    setAnswers: (data: Omit<ITravelStatus, 'status'>) => void;
  };
  setIsEdited: () => void;
}
export const TravelPrevented = ({
  travelStatus,

  additionalAnswers: { setAnswers },
  setIsEdited,
  setComplete,
}: IProps) => {
  const [reason, setReason] = useState(travelStatus.travelPreventedReason);

  useEffect(() => {
    setComplete(true);
  }, [setComplete]);

  useEffect(() => {
    setAnswers({ travelPreventedReason: reason });
  }, [reason, setAnswers]);

  return (
    <>
      <TextareaWithConfirm
        value={reason}
        label={`Note to appear on status (optional)`}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          setReason(event.currentTarget.value);
          setIsEdited();
        }}
      />
    </>
  );
};
